module.exports = __webpack_public_path__ + "r-v3/img/ml_22_01_over.3336c34c.jpg";